import React from 'react';
import { Outlet } from 'react-router-dom';

const ShipmentMngPage = () => {
  return <Outlet />;
};

export default ShipmentMngPage;
